import React from "react";
import { Card } from "antd";

/**
 * Overzichtskaart: filterbalk bovenin, tabel eronder, optionele voetnoot.
 *
 * De filters zitten in de kaart zelf (niet erboven), zodat zichtbaar is dat ze
 * bij déze tabel horen. De voetnoot is voor uitleg die anders in een tooltip
 * zou verdwijnen — bijvoorbeeld hoe een pro forma verrekend raakt.
 */
const ListCard = ({ filters, children, footnote, bodyStyle }) => (
  <>
    <Card styles={{ body: { padding: 0, ...bodyStyle } }}>
      {filters ? (
        <div
          style={{
            padding: 12,
            borderBottom: "1px solid rgba(5, 5, 5, 0.06)",
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            alignItems: "center",
          }}
        >
          {filters}
        </div>
      ) : null}
      {children}
    </Card>
    {footnote ? (
      <div style={{ marginTop: 12, fontSize: 12, color: "rgba(0, 0, 0, 0.4)" }}>{footnote}</div>
    ) : null}
  </>
);

export default ListCard;
